import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import BookIdea from './pages/BookIdea';
import CharacterDetails from './pages/CharacterDetails';
import EditCharacter from './pages/EditCharacter';
import Profile from './pages/Profile';
import PenNameProfile from './pages/PenNameProfile';
import Auth from './pages/Auth';
import NewIdea from './pages/NewIdea';
import EditIdea from './pages/EditIdea';
import Settings from './pages/Settings';
import ChangePassword from './pages/ChangePassword';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import IpProtection from './pages/IpProtection';
import Admin from './pages/Admin';
import AuthorDashboard from './pages/AuthorDashboard';
import AuthorAnalytics from './pages/AuthorAnalytics';
import BookEditor from './pages/BookEditor';
import ReaderDashboard from './pages/beta/ReaderDashboard';
import BetaAuthorDashboard from './components/beta/AuthorDashboard';
import SSOCallback from './components/SSOCallback';
import Discussion from './pages/Discussion';
import { useAuth } from './hooks/useAuth';
import { ThemeProvider } from './contexts/ThemeContext';

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-t-transparent rounded-full animate-spin border-purple-600" />
      </div>
    );
  }

  return (
    <ThemeProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/idea/:id" element={<BookIdea />} />
          <Route path="/idea/:id/edit" element={<EditIdea />} />
          <Route path="/idea/:ideaId/discussion/:commentId" element={<Discussion />} />
          <Route path="/idea/:ideaId/character/:characterId" element={<CharacterDetails />} />
          <Route path="/idea/:ideaId/character/:characterId/edit" element={<EditCharacter />} />
          <Route path="/profile/:id" element={<Profile />} />
          <Route path="/pen-name/:id" element={<PenNameProfile />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/auth/callback" element={<SSOCallback />} />
          <Route path="/new-idea" element={<NewIdea />} />
          <Route path="/settings" element={user ? <Settings /> : <Navigate to="/auth" state={{ returnTo: '/settings' }} />} />
          <Route path="/settings/password" element={user ? <ChangePassword /> : <Navigate to="/auth" state={{ returnTo: '/settings/password' }} />} />
          <Route path="/dashboard" element={user ? <AuthorDashboard /> : <Navigate to="/auth" state={{ returnTo: '/dashboard' }} />} />
          <Route path="/dashboard/analytics" element={user ? <AuthorAnalytics /> : <Navigate to="/auth" state={{ returnTo: '/dashboard/analytics' }} />} />
          <Route path="/editor" element={user ? <BookEditor /> : <Navigate to="/auth" state={{ returnTo: '/editor' }} />} />
          <Route path="/beta/reader" element={user ? <ReaderDashboard user={user} /> : <Navigate to="/auth" state={{ returnTo: '/beta/reader' }} />} />
          <Route path="/beta/author" element={user ? <BetaAuthorDashboard user={user} /> : <Navigate to="/auth" state={{ returnTo: '/beta/author' }} />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/ip-protection" element={<IpProtection />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Layout>
    </ThemeProvider>
  );
}